import { Outlet } from 'react-router-dom';

/**
 * Shell for the pre-authentication screens.
 *
 * No navigation, no chrome — there is nothing a signed-out user may reach, so showing
 * a sidebar would only advertise doors that are locked.
 */
export function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <main className="flex flex-1 items-center justify-center px-4 py-10">
        <div className="w-full max-w-[440px]">
          {/*
            The full lockup on the sign-in screen, where there is room for it — this is
            the one place someone needs to know WHOSE system they are signing in to.

            On a white card in both themes: the lockup is dark artwork with a black
            "ACADEMY" band, and on the dark canvas the band disappears and the grey
            figures with it. The card is the brand's own background, not a recolouring
            of its logo.
          */}
          <div className="mb-6 flex flex-col items-center gap-3">
            <span className="rounded-lg bg-white px-6 py-4 shadow-xs">
              <img
                src="/icons/logo-lockup.png"
                alt="Bemedic Academy"
                width={720}
                height={332}
                className="h-14 w-auto"
              />
            </span>
            <span className="text-h3 font-semibold tracking-tight">BM-Work</span>
          </div>
          <Outlet />
        </div>
      </main>

      <footer className="pb-8 text-center text-caption text-fg-muted">
        Bemedic Academy · Internal system
      </footer>
    </div>
  );
}

export function AuthCard({
  title,
  description,
  children,
  footer,
}: {
  title: string;
  description?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}) {
  return (
    <div className="rounded-lg border border-line bg-surface p-6 shadow-sm">
      <div className="mb-5 space-y-1">
        <h1 tabIndex={-1} className="text-h2 outline-none">
          {title}
        </h1>
        {description && <p className="text-body text-fg-muted">{description}</p>}
      </div>
      {children}
      {footer && <div className="mt-5 border-t border-line pt-4 text-caption">{footer}</div>}
    </div>
  );
}
